import { ADMIN_API } from "./adminApi";
import { ApiOk, ChartPoint } from "./adminCommon.types";

export type AdminDashboardSummary = {
  clientesAtivos: number;
  lojasShopify: number;
  lojasNuvemshop: number;
  enviosHoje: number;
  apisOnline: number;
  totalIntegracoes: number;
  integracoesComErro: number;
  ultimasSincronizacoes: Array<{
    id: number;
    integration: string;
    status: "ok" | "error";
    message: string | null;
    createdAt: string;
  }>;
};

export type AdminDashboardPeriodSummary = {
  enviosNoPeriodo: number;
  etiquetasEmitidas: number;
};

export type DashboardDateRange = {
  date_from?: string;
  date_to?: string;
};

export type ValorPorClienteItem = {
  clienteId: number;
  label: string;
  envios: number;
  totalUsd: number;
  value: number | null;
};

export const getAdminDashboardSummary = async () => {
  const { data } = await ADMIN_API.get<ApiOk<AdminDashboardSummary>>("/api/admin/dashboard/summary");
  return data.data;
};

export const getAdminDashboardPeriodSummary = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<AdminDashboardPeriodSummary>>("/api/admin/dashboard/period-summary", {
    params: range,
  });
  return data.data;
};

export const getEnviosPorDia = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>("/api/admin/dashboard/charts/envios-por-dia", { params: range });
  return data.data;
};

export const getCrescimentoMensal = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>("/api/admin/dashboard/charts/crescimento-mensal", { params: range });
  return data.data;
};

export const getDistribuicaoTransportadora = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>("/api/admin/dashboard/charts/distribuicao-transportadora", { params: range });
  return data.data;
};

export const getNovosClientes = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>("/api/admin/dashboard/charts/novos-clientes", { params: range });
  return data.data;
};

export const getPedidosImportadosChart = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>("/api/admin/dashboard/charts/pedidos-importados", { params: range });
  return data.data;
};

export const getValorPorCliente = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ValorPorClienteItem[]> & { dolar: number | null }>(
    "/api/admin/dashboard/charts/valor-por-cliente",
    { params: range }
  );
  return { data: data.data, dolar: data.dolar };
};

export type PaisEnvios = { pais: string; total: number };

export const getEnviosPorPais = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<PaisEnvios[]>>("/api/admin/dashboard/charts/envios-por-pais", { params: range });
  return data.data;
};

export const getFunilConversao = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>("/api/admin/dashboard/charts/funil-conversao", { params: range });
  return data.data;
};

export const getSlaTransportadora = async (range?: DashboardDateRange) => {
  const { data } = await ADMIN_API.get<ApiOk<Array<{ label: string; value: number; total: number }>>>(
    "/api/admin/dashboard/charts/sla-transportadora",
    { params: range }
  );
  return data.data;
};

export const getPrimeiraAtividade = async () => {
  const { data } = await ADMIN_API.get<ApiOk<{ primeiraAtividade: string }>>(
    "/api/admin/dashboard/primeira-atividade"
  );
  return data.data.primeiraAtividade;
};

export type DashboardEvento = {
  id: string;
  type: "pedido_importado" | "etiqueta_emitida" | "sync_error";
  titulo: string;
  detalhe: string;
  valorUsd?: number | null;
  valorBrl?: number | null;
  createdAt: string;
};

export const getEventosRecentes = async (since?: string) => {
  const { data } = await ADMIN_API.get<ApiOk<DashboardEvento[]> & { serverTime: string }>(
    "/api/admin/dashboard/eventos-recentes",
    { params: since ? { since } : undefined }
  );
  return { eventos: data.data, serverTime: data.serverTime };
};
